"use client";

import { AdUnit } from "./ad-unit";

type InFeedAdProps = {
  slot: string;
  className?: string;
};

export function InFeedAd({ slot, className }: InFeedAdProps) {
  return (
    <div className={`my-6 flex justify-center ${className ?? ""}`}>
      <AdUnit className="w-full" format="auto" slot={slot} />
    </div>
  );
}
